import { render, staticRenderFns } from "./UserFormChangePassword.vue?vue&type=template&id=cd71fdd2&"
import script from "./UserFormChangePassword.vue?vue&type=script&lang=js&"
export * from "./UserFormChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports